module.exports = {
  title: `🔧 ino.bio 🧬`,
  description: `Blog about tools for cancer genomics`,
  author: `inodb`,
  introduction: `building tools for cancer genomics`,
  siteUrl: `https://ino.bio`, // Your blog site url
  social: {
    linkedin: `inodb`, // Your LinkedIn account
    github: `inodb`, // Your GitHub account
    medium: ``, // Your Medium account
    facebook: ``, // Your Facebook account
    googlescholar: `Pze5p28AAAAJ`, // Your Google Scholar account
    cv: `https://cv.ino.bio` // Your CV link
  },
  icon: `content/assets/favicon.png`, // Add your favicon
  keywords: [`blog`,`bioinformatics`],
  comment: {
    disqusShortName: '', // Your disqus-short-name. check disqus.com.
    utterances: '', // Your repository for archive comment
  },
  configs: {
    countOfInitialPost: 10, // Config your initial count of post
  },
  sponsor: {
    buyMeACoffeeId: '',
  },
  share: {
    facebookAppId: '', // Add facebookAppId for using facebook share feature v3.2
  },
  ga: 'UA-151067668-1', // Add your google analytics tracking ID
}
